export const widgetPlanIds = {
  scandy: {
    city: {
      standard: '21a83be8-1a5c-42e9-a10e-474d201c052d',
      panoramic: 'be44d8fb-1f1c-470d-9a51-c1b84d3217c2',
    },
    sandy_shore: {
      standard: 'd80cf52d-3231-44f2-8fdf-f6f10e5843a4',
      panoramic: 'fbca1d47-2732-4f28-8bd5-a9c01eeaf783',
    },
    garden: {
      standard: 'c46e431b-252e-4f66-b133-453bbd984764',
      panoramic: 'de6b0789-7d3a-4ecb-a2c7-56562078685b',
    },
    village: {
      standard: '6ec0268a-5e6e-47f3-a560-7ec80806b579',
      panoramic: '47e4397a-4da6-48b1-bf0c-40c08cfee368',
    },
    pool: {
      standard: '7ed25df1-ba2a-4a47-8c2e-9b6f7c9aac8f',
      panoramic: '59ca5f6b-8343-456a-b61e-2fd1abf3a546',
    },
    summer_town: {
      standard: 'eca6abc7-a548-4f23-9b0e-d9697b03d2b7',
      panoramic: 'c3b946b8-fcbd-4778-b965-5b003a2fc1d9',
    },
    mountains: {
      standard: '144fffe0-2a05-40f7-b6f3-c945cd7055aa',
      panoramic: 'fc387666-65d1-40ce-9048-d94b65f6ca3b',
    },
  },
  england: {
    city: {
      standard: '0412c2dc-a3c4-4d3b-af5e-6722039b6082',
      panoramic: 'eea26b8e-3a4e-4e2b-b4d2-9abd5d19ff03',
    },
    sandy_shore: {
      standard: '08dcc9ef-699d-4c1a-b0f8-6bc86b999b74',
      panoramic: 'd5f22ddf-9c88-461f-b0e6-096a95f1c675',
    },
    garden: {
      standard: '4587f92f-2c09-485c-922f-495d8a32fa61',
      panoramic: 'eb3f6f50-6abd-42ff-b9ea-085317263b3a',
    },
    village: {
      standard: '6e972982-e0ca-4e1b-aca9-84ac67c5a62f',
      panoramic: 'a263a980-29f7-47df-aab7-932aabf3ef37',
    },
    pool: {
      standard: '6c82f642-1502-499b-a701-1c059ac8f5cb',
      panoramic: '032683a0-1e39-400c-84d2-cf55b95c7300',
    },
    summer_town: {
      standard: '6c82f642-1502-499b-a701-1c059ac8f5cb',
      panoramic: 'a419893d-e366-4abe-9962-a75f758c18ea',
    },
    mountains: {
      standard: 'cb49c58e-6903-40f0-8a56-097503f66752',
      panoramic: '7ab8fdb8-e19d-42d9-854e-519b432be4b7',
    },
  },
  boho: {
    city: {
      standard: '0ddefec5-591b-4c82-bb90-3169a05d22e9',
      panoramic: 'e92ed6cc-5414-4ede-9049-ffa6de708d32',
    },
    sandy_shore: {
      standard: '2db348ea-13f4-4c95-939a-685cef4b314a',
      panoramic: '4d68d7f7-ce44-48ec-8410-fd008b63974e',
    },
    garden: {
      standard: '7582006c-c12e-492b-a5b1-3910838d9bc1',
      panoramic: '30f57906-1e79-4f09-b6d3-cfbb1671c84b',
    },
    village: {
      standard: 'a0c53eb3-ed06-4039-87eb-41e03bc81797',
      panoramic: '438cab24-63c4-440e-a18a-0787f4585b1d',
    },
    pool: {
      standard: '9abd0d1a-4aed-4540-9736-e5a8dcc6bfed',
      panoramic: '96a820a0-3b9a-4664-b500-b7a00c76943c',
    },
    summer_town: {
      standard: 'dfd32cb5-353e-49ce-9be7-a66dbcaa6fda',
      panoramic: '5efdb037-154a-497f-9deb-3fdefd75a041',
    },
    mountains: {
      standard: '6cb8c526-801b-4a9a-9888-f1a02d8d9caf',
      panoramic: '358413e6-5f5c-4485-b77d-0810f14128b7',
    },
  },
  zero: {
    city: {
      standard: 'cbf5f747-8498-4208-88c7-0e81358e799c',
      panoramic: '1e34e948-5f94-4e57-901e-b8c55a27daab',
    },
    sandy_shore: {
      standard: '83f88442-6582-4f3d-879a-e2a14513d72c',
      panoramic: '72a16a6c-5383-4975-9e49-373306e928e2',
    },
    garden: {
      standard: '530bbbe5-3ab7-4a8e-b812-c9a5227b5362',
      panoramic: '54a88ea3-6069-451b-a4fd-28d974f06c0a',
    },
    village: {
      standard: '700bace5-01df-442a-b123-97fe9047420b',
      panoramic: '4ff57627-3c5a-41f1-bb25-fdbc381c8a17',
    },
    pool: {
      standard: '2631b3c7-8452-4161-80b3-f271db5603f0',
      panoramic: '1e1949e2-112d-4a0f-b599-865da07e8c34',
    },
    summer_town: {
      standard: 'e4c2ae4c-b84c-4c5e-8e99-3cc350fda6eb',
      panoramic: '55d4f16a-d93e-4f91-857a-2ac47b3b19b6',
    },
    mountains: {
      standard: 'c1a5509e-1e20-467c-9fb0-8ef0fd075e97',
      panoramic: 'e0000d2a-bec6-4727-ad38-a1c30055655c',
    },
  },
  modern: {
    city: {
      standard: 'e2485828-e35e-4294-8cdf-4439fedde4f4',
      panoramic: '6cf59513-70c1-454d-9ff2-f2a437a726e7',
    },
    sandy_shore: {
      standard: 'da0e9e3c-aae8-4234-92d0-3f3a7a907bf8',
      panoramic: '3fe02e10-7a94-493e-9430-1593966f2599',
    },
    garden: {
      standard: '2ca1a451-889d-4ef1-b629-66d230a6f101',
      panoramic: 'eb67f40d-0907-4f25-85bf-f3f2de24190d',
    },
    village: {
      standard: '044aa4ce-b32b-401c-958f-8c7c93d6739a',
      panoramic: '25cf236b-b21c-481a-82e3-a172a9b65a47',
    },
    pool: {
      standard: 'e4104860-7abd-4bb5-b44b-297a517238e4',
      panoramic: 'dcab235e-3450-47a3-9419-f7e5ec291f18',
    },
    summer_town: {
      standard: '1a601d49-60f9-4e28-a16d-c36e0933039d',
      panoramic: 'a904cdf2-07fc-4c90-8cf7-ee41a6300925',
    },
    mountains: {
      standard: '0e723a37-9111-4432-86de-820358b4f86a',
      panoramic: '812e416b-f89f-4baf-bf8f-5744718bf30e',
    },
  },
  japandi: {
    city: {
      standard: '2283a6d4-0d4c-444f-b9c1-a9443f7ec43e',
      panoramic: '8c092329-676c-4efb-b946-783705f1527e',
    },
    sandy_shore: {
      standard: 'cc1690d3-b42c-47b3-b66f-8b0e29f02bff',
      panoramic: 'e446a09b-5561-4e38-af97-5135771c5d63',
    },
    garden: {
      standard: 'ba59bfb0-f44c-43a5-9f43-b1ceabdcf50a',
      panoramic: '382ad477-f6e2-410a-95e8-11a8598155a6',
    },
    village: {
      standard: '864fe7d5-9572-4c27-8f52-44c815ace221',
      panoramic: '013207ec-35fb-4b5e-ae2e-10346e789a65',
    },
    pool: {
      standard: '6589f3f5-517a-4312-933f-0087c3301800',
      panoramic: 'a2050775-389f-4078-8ff0-c6145b529b47',
    },
    summer_town: {
      standard: '92383410-90a8-4c28-8917-994aa147096c',
      panoramic: '91df20f5-9cf1-4c00-85de-ffd0989073d2',
    },
    mountains: {
      standard: '027c8924-1569-40c0-869e-718813d8505c',
      panoramic: '7181db5a-f29c-468d-9aec-d30b708043a3',
    },
  },
  elegance: {
    city: {
      standard: '15771fd3-30ac-4bf3-ad22-c79e4c5b2a81',
      panoramic: '1034d9f0-7db9-48f1-955e-293832dde67b',
    },
    sandy_shore: {
      standard: '38ef1e2e-aef4-4c08-bc11-1cf9f287c18b',
      panoramic: '745b380e-b23a-40dc-a098-f30a9928dc3e',
    },
    garden: {
      standard: 'a43edd6b-e5b2-480d-8e67-d26877f59b44',
      panoramic: '537faf4b-f7ff-46ca-a016-b5a5ca70ff6f',
    },
    village: {
      standard: 'ee25615e-b3f0-4208-bfca-7b1263df907a',
      panoramic: '325e70b0-c99b-4eb8-8390-3179c9c7992f',
    },
    pool: {
      standard: '6a321cbe-2160-4da2-a9c1-deb46d94657e',
      panoramic: '8547fb28-f696-4507-acc6-e214a29b2d9d',
    },
    summer_town: {
      standard: '52ac04ff-318b-4dbf-9a94-91e6adceafcd',
      panoramic: '58b459cd-3db1-4ad5-bf32-ce54b6d2934a',
    },
    mountains: {
      standard: 'a300c0ea-5fab-4d2a-ae7e-97bf5fc8f831',
      panoramic: 'd51e59ae-78c8-4cda-a12c-60c9161e5e22',
    },
  },
  american: {
    city: {
      standard: '1096d1cf-6f13-44d3-a2b1-b8b85914e314',
      panoramic: 'c3c5db31-1581-4870-bbac-74f009f47fb0',
    },
    sandy_shore: {
      standard: '9afa7d9a-75f8-4c70-8496-7e971b28953f',
      panoramic: '55afed11-6ab7-481f-acfa-c37d878b56b1',
    },
    garden: {
      standard: 'a84b4556-a9c3-4a80-b055-fde4fda90eef',
      panoramic: '8329fd9e-cb6f-4624-ae84-48992b9b40fa',
    },
    village: {
      standard: 'e19916e3-4c2a-492a-99f5-96fe95bef4cb',
      panoramic: '1eaf4dca-8521-4b6e-91c4-eab6025a0ab2',
    },
    pool: {
      standard: 'b62c72e7-db63-4b41-8946-7006322f0cc8',
      panoramic: 'c8cf0326-7f64-4c27-99ed-d14ac8c5b653',
    },
    summer_town: {
      standard: '1ab89b0d-e8c7-463b-bd60-54f62e63c18d',
      panoramic: 'bf7c49f9-8db7-495e-9745-f980c0d36bde',
    },
    mountains: {
      standard: '29f31099-8b14-485f-8b5a-d3aff956cd53',
      panoramic: '518bc4d3-7e50-47d4-a2cf-289bf447392c',
    },
  },
  contemporary: {
    city: {
      standard: '3c0b8544-65aa-407c-96d4-c151c7036c1a',
      panoramic: '0086095d-7d73-4421-bad1-101c74e51e12',
    },
    sandy_shore: {
      standard: '54e5e54f-5977-4718-9bdb-f011e1df6d5e',
      panoramic: '0d0d7803-49f9-43bc-8700-766f78875723',
    },
    garden: {
      standard: 'ed611a49-a46a-446c-8332-f218f38b16c9',
      panoramic: 'ac5a520d-d2a5-4886-958d-0be33e502659',
    },
    village: {
      standard: '5d004ddf-641b-4637-93db-b593bab1f0a6',
      panoramic: '13140fd0-6b68-4966-b241-9c5c05df322c',
    },
    pool: {
      standard: '302fee06-499a-485e-9c4d-a50d6c89d41b',
      panoramic: '8dfbd370-b62c-41b0-aaeb-3e0e58e6730c',
    },
    summer_town: {
      standard: '64b91596-b1b8-4ea5-b69d-09660c93d551',
      panoramic: '0cdf3aca-6422-41dc-9a9d-623fe8c8a4ad',
    },
    mountains: {
      standard: '9d1789d3-d32d-44d6-842f-c790644b3d99',
      panoramic: '4cae97a6-0c73-4a1b-b9c9-de364d588818',
    },
  },
};
